import { render } from "./noupload.vue?vue&type=template&id=2f6cc036&scoped=true"
import script from "./noupload.vue?vue&type=script&lang=js"
export * from "./noupload.vue?vue&type=script&lang=js"

import "./noupload.vue?vue&type=style&index=0&id=2f6cc036&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6cc036"]])

export default __exports__